'use client';

import { useSearchParams } from 'next/navigation';

import { isMobileUtMode, MobileUtPhoneShell } from '@/shared-survey';
import { useIsDesktop } from '@/shared-utilities';
import {
  type GetProjectQuery,
  type InitiateSurveyV3Mutation,
} from '@/survey-graphql';

import { MIN_USABILITY_VIEWPORT_HEIGHT } from './project-response.consts';
import ProjectUsabilityResponseHandsFree from './project-usability-response-handsfree';

interface Props {
  project: GetProjectQuery['project'];
  orgSettings?: GetProjectQuery['projectOrgSettings'];
  sessionId: string;
  firstQuestion: InitiateSurveyV3Mutation['initiateSurveyV3']['firstQuestion'];
}

export default function UsabilityTestHandsFreeWrapper({
  project,
  orgSettings,
  sessionId,
  firstQuestion,
}: Props) {
  const searchParams = useSearchParams();
  const isInsideHyperbeam = isMobileUtMode(searchParams);
  const { isDesktop, mounted } = useIsDesktop(
    1100,
    MIN_USABILITY_VIEWPORT_HEIGHT
  );

  if (!mounted) {
    return (
      <div className='flex h-screen w-screen items-center justify-center bg-neutral-950' />
    );
  }

  // Inside Hyperbeam VM: always render HandsFree regardless of viewport size.
  // The VM viewport matches the phone screen but it's a desktop browser environment.
  if (isInsideHyperbeam) {
    return (
      <ProjectUsabilityResponseHandsFree
        project={project}
        orgSettings={orgSettings}
        sessionId={sessionId}
        firstQuestion={firstQuestion}
      />
    );
  }

  if (!isDesktop) {
    return (
      <MobileUtPhoneShell
        projectId={project.id}
        sessionId={sessionId}
        title={project.publicTitle || project.title || 'User Test'}
      />
    );
  }

  return (
    <ProjectUsabilityResponseHandsFree
      project={project}
      orgSettings={orgSettings}
      sessionId={sessionId}
      firstQuestion={firstQuestion}
    />
  );
}
